import * as yup from "yup";

const validation = (messages, includedChildren = []) => {
  const schemaShape = {};

  includedChildren.forEach(({ userId, age }) => {
    if (age >= 16) {
      schemaShape[`healthInsuranceRightsCertificate_${userId}`] = yup
        .array()
        .of(
          yup.object().shape({
            name: yup.string().required(messages.REQUIRED),
          })
        )
        .required(messages.REQUIRED_ATTACHMENT)
        .min(1, messages.REQUIRED_ATTACHMENT)
        .max(1, messages.ONE_FILE);
    }
    if (age >= 18) {
      schemaShape[`dependentProof_${userId}`] = yup
        .array()
        .of(
          yup.object().shape({
            name: yup.string().required(messages.REQUIRED),
          })
        )
        .required(messages.REQUIRED_ATTACHMENT)
        .min(1, messages.REQUIRED_ATTACHMENT)
        .max(1, messages.ONE_FILE);
    }
  });

  return yup.object().shape(schemaShape);
};

export default validation;
